import { STATUS_BOOKED, TEACHER_ROLE } from "../constants";
// import ZoomIcon from "../assets/images/zoom.png";
import ZoomIcon from "../assets/images/video-camera.png";
import { toast } from "react-toastify";
import { firestore } from "../firebase/config";
import { doc, collection, query, where, getDocs } from "firebase/firestore";
import { baseUrl } from "../services/api";
import moment from "moment";
import { addofferSlotIdOnMeetingLink } from "../services/offer-slots";

import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { DateTime } from "luxon";
import countryData from "./country_codes.json";
export const getUnreadMessagesCount = async (chatId, userId) => {
  try {
    const chatRef = doc(firestore, `chats/${chatId}`);
    const messagesQuery = query(
      collection(chatRef, "messages"),
      where("receiverId", "==", userId),
      where("seen", "==", false)
    );

    const messagesSnapshot = await getDocs(messagesQuery);
    return messagesSnapshot.size;
  } catch (error) {
    console.error("Error fetching unread count:", error);
    return 0;
  }
};

export const getFormattedTime = (timestamp) => {
  const date = new Date(timestamp * 1000); // Convert to milliseconds

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12; // Convert 0 to 12 for noon/midnight

  // return `${year}-${month}-${day} ${formattedHours}:${
  //   minutes < 10 ? "0" : ""
  // }${minutes} ${ampm}`;
  return `${formattedHours}:${minutes < 10 ? "0" : ""}${minutes} ${ampm}`;
};

export const getFormatedMessageTime = (timestamp) => {
  if (!timestamp) return "";

  // Convert to UTC+5 (Pakistan Standard Time)
  const localMoment = moment.utc(timestamp).utcOffset(5 * 60);

  // Get today's date at midnight in UTC+5
  const today = moment()
    .utcOffset(5 * 60)
    .startOf("day");
  const messageDay = localMoment.clone().startOf("day");
  const diffDays = today.diff(messageDay, "days");

  let dayLabel;
  if (diffDays === 0) {
    dayLabel = "Today";
  } else if (diffDays === 1) {
    dayLabel = "Yesterday";
  } else if (diffDays < 7) {
    dayLabel = `${diffDays} days ago`;
  } else {
    dayLabel = localMoment.format("MMM D, YYYY");
  }

  const time = localMoment.format("h:mm A");
  return `${dayLabel} at ${time}`;
};

export const formatMessage = (message, maxWordsPerLine) => {
  const words = message?.split(" ");
  const lines = [];

  while (words?.length > 0) {
    lines.push(words?.splice(0, maxWordsPerLine)?.join(" "));
  }

  return lines?.join("\n");
};

/**
 * clear local storage
 */
export const clearLocalStorage = () => {
  window.localStorage.clear();
  window.location.href = "/";
};

export const convertTo12HourFormat = (time24) => {
  // Split the input time into hours, minutes, and seconds
  const [hour, minutes] = time24?.split(":").map(Number);

  // Determine if it's AM or PM
  const period = hour >= 12 ? "PM" : "AM";

  // Convert to 12-hour format
  let hour12 = hour % 12;
  if (hour12 === 0) {
    hour12 = 12; // 0 in 24-hour format is 12 in 12-hour format
  }

  // Create the formatted time string without seconds
  const time12 = `${hour12}:${String(minutes).padStart(2, "0")} ${period}`;

  return time12;
};

/**
 * Converts a UTC time to the user's local timezone and formats it in 12-hour format
 * @param {string} utcTime - The UTC time string (can be ISO format or any format Luxon can parse)
 * @param {string} format - Optional custom format, defaults to 12-hour time format
 * @returns {string} Formatted time in user's local timezone
 */
export const formatUtcToLocalTime = (utcTime, format = "hh:mm a") => {
  if (!utcTime) return "";

  try {
    const dateTime = DateTime.fromISO(utcTime, { zone: "utc" });
    if (!dateTime.isValid) {
      console.error("Invalid date format:", utcTime);
      return "";
    }

    return dateTime.toLocal().toFormat(format);
  } catch (error) {
    console.error("Error formatting time:", error);
    return "";
  }
};

export const formatDate = (inputDate) => {
  // Handle invalid or missing input
  if (!inputDate || typeof inputDate !== "string") {
    return "Invalid Date";
  }

  // Convert input string to a Date object
  const dateObj = new Date(inputDate);

  // Check if the Date object is valid
  if (isNaN(dateObj.getTime())) {
    console.warn(`Invalid date format for input: ${inputDate}`); // Log for debugging
    return "Invalid Date";
  }

  // Define arrays for day names and month names
  const dayNames = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract day, month, and year using UTC methods
  const dayName = dayNames[dateObj.getUTCDay()];
  const monthName = monthNames[dateObj.getUTCMonth()];
  const day = dateObj.getUTCDate();
  const year = dateObj.getUTCFullYear();

  // Create the formatted date string
  const formattedDate =
    dayName +
    ", " +
    monthName +
    " " +
    (day < 10 ? "0" : "") +
    day +
    ", " +
    year;

  return formattedDate;
};

// Iterate through the slots and update the status if the start time has passed
export const updateSlotStatusToExpire = (slots, currDay) => {
  const currentDay = new Date().toLocaleDateString("en-US", {
    weekday: "long",
  });
  const currentTime = new Date()
    .toLocaleTimeString("en-US", { hour12: false })
    .slice(0, 5); // Remove seconds

  const updatedSlots = slots.map((slot) => {
    if (
      currDay === currentDay &&
      slot?.status !== STATUS_BOOKED &&
      slot?.startTime < currentTime
    ) {
      slot.status = "expire";
    }
    return slot;
  });

  return updatedSlots;
};

export const formatChatDate = (dateString) => {
  const dateObj = new Date(dateString);

  // Define an array of month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Get the month name, date, and year components
  const monthName = monthNames[dateObj.getMonth()];
  const date = dateObj.getDate();
  // const year = dateObj.getFullYear();
  const year = dateObj.getFullYear().toString().slice(-2);

  // Format the date string
  const formattedDate = `${date}-${monthName}-${year}`;

  return formattedDate;
};

// Get country info by dial code prefix
const getCountryByDialCode = (number) => {
  return countryData.find((country) =>
    number.startsWith(country.dial_code.replace("+", ""))
  );
};

export const formatInternationalPhoneNumber = (number) => {
  if (typeof number !== "string") return number;

  const cleaned = number.replace(/\D/g, ""); // remove non-digits

  // Try to match with a country by dial code
  const matchedCountry = getCountryByDialCode(cleaned);

  if (!matchedCountry) return number; // unknown format

  const dialCode = matchedCountry.dial_code.replace("+", "");
  const nationalNumber = cleaned.slice(dialCode.length);

  // Special formatting for Pakistan
  if (matchedCountry.code === "PK" && nationalNumber.length === 10) {
    const code = nationalNumber.slice(0, 3);
    const mid = nationalNumber.slice(3, 6);
    const end = nationalNumber.slice(6);
    return {
      // formatted: `+${dialCode} ${code}-${mid}-${end}`,
      formatted: `${code}-${mid}-${end}`, //without dial code
      flag: matchedCountry.flag,
      country: matchedCountry.name,
    };
  }

  // Default formatting for others: +CC NNN... (basic spacing)
  return {
    formatted: `+${dialCode} ${nationalNumber}`,
    flag: matchedCountry.flag,
    country: matchedCountry.name,
  };
};

export const handleSlotIdSend = async (offerSlotId, role) => {
  try {
    let payload = {};
    if (role === TEACHER_ROLE) {
      payload.teacherClickedMeeting = true;
      payload.teacherMeetingClickedDateTime = new Date();
    } else {
      payload.studentClickedMeeting = true;
      payload.studentMeetingClickedDateTime = new Date();
    }

    let { status, data } = await addofferSlotIdOnMeetingLink(
      offerSlotId,
      payload
    );
    if (status === 200) {
      // console.log("data", data);
    } else {
      reactToast("error", "Something went wrong!");
    }
  } catch (error) {
    reactToast("error", "Something went wrong!");
  }
};

window.handleJoinNow = (url, offerSlotId, role) => {
  if (offerSlotId !== "undefined") handleSlotIdSend(offerSlotId, role);
  window.open(url, "_blank");
};

// This function finds and replaces URLs with anchor tags
export const makeLinksClickable = (text, message, role) => {
  // console.log(" makeLinksClickable message", message, role);
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  return text?.replace(urlRegex, (url) => {
    return `
      <div class="">
        <div class="d-flex justify-content-between align-items-center" style="gap: 10px; max-width: 300px; ">
          <img src="${ZoomIcon}" style="height: 28px;" alt="Zoom Image" class="zoom-image" />
          <span class="d-flex font-size-13px">Let's meet up now</span>
          <button class="btn btn-primary fs_12"
          style="color: #fff; background-color: #008000; border: none;" 
          
          
          onclick="window.handleJoinNow('${url}', '${message?.offerSlotId}', '${role}')">Join Now</button>
        </div>
        <div class="d-flex justify-content-end mt-2">
          <div>
              <p class="font-size-12px mb-0">The meeting link will expire after 5 minutes.</p>
          </div>
        </div>
      </div>
    `;
  });
};

export const reactToast = (type, text) => {
  toast[type || "success"](text);
};

export const getErrorMessages = (errors) => {
  let errorMessages = {};

  errors?.inner?.forEach((err) => {
    errorMessages[err.path] = err.message;
  });
  return errorMessages;
};

export const extractHoursAndMinutes = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0"); // Ensure 2-digit format
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12; // Convert 24-hour format to 12-hour format

  return `${formattedHours}:${minutes} ${ampm}`;
};

export const getLastDayOfMonth = () => {
  // Get today's date
  const today = new Date();

  // Get the current month and year
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();

  // Calculate the last day of the month
  const lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0);

  // Format the last day of the month as YYYY-MM-DD
  const formattedLastDayOfMonth = `${lastDayOfMonth.getFullYear()}-${(
    lastDayOfMonth.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${lastDayOfMonth.getDate().toString().padStart(2, "0")}`;

  return formattedLastDayOfMonth;
};

export const getTodayDate = () => {
  // Get today's date
  const today = new Date();

  // Get the year, month, and day
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, "0"); // Add 1 to month since it's zero-based
  const day = today.getDate().toString().padStart(2, "0");

  // Format the date as "YYYY-MM-DD"
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
};

/**
 * Formats event data by converting UTC date and times to the user's local timezone
 * @param {Array} data - Array of event objects with date, startTime, and endTime in UTC
 * @returns {Array} - Formatted events with start and end times in local timezone
 */
export const formatEventData = (data) => {
  const events = data.map((item) => {
    const startDateTime = DateTime.fromISO(`${item.date}T${item.startTime}`, {
      zone: "utc",
    }).toLocal();
    const endDateTime = DateTime.fromISO(`${item.date}T${item.endTime}`, {
      zone: "utc",
    }).toLocal();

    // Create JavaScript Date objects from the local DateTime objects
    // This is necessary for react-big-calendar which expects Date objects
    const localStartDate = startDateTime.toJSDate();
    const localEndDate = endDateTime.toJSDate();

    return {
      ...item,
      id: item.id,
      start: localStartDate, // Use the local timezone start date
      end: localEndDate, // Use the local timezone end date
      title: item.student.fullName,
      localStartTime: startDateTime.toFormat("hh:mm a"),
      localEndTime: endDateTime.toFormat("hh:mm a"),
      localDate: startDateTime.toFormat("yyyy-MM-dd"),
    };
  });

  // console.log("events", events);
  return events;
};

export const getMonthStartEndDates = (date) => {
  // // Get the year and month from the given date
  // const year = date.getFullYear();
  // const month = date.getMonth();

  // // Calculate the start date of the month
  // const startDate = new Date(year, month, 1).toISOString().slice(0, 10);

  // // Calculate the end date of the month
  // const endDate = new Date(year, month + 1, 0).toISOString().slice(0, 10);
  // return { startDate, endDate };

  const startDate = moment().startOf("month").format("YYYY-MM-DD");
  const endDate = moment().endOf("month").format("YYYY-MM-DD");

  return { startDate, endDate };
};

export const formatStudentEventData = (data) => {
  const events = data.map((item) => {
    const startDateTime = DateTime.fromISO(`${item.date}T${item.startTime}`, {
      zone: "utc",
    }).toLocal();
    const endDateTime = DateTime.fromISO(`${item.date}T${item.endTime}`, {
      zone: "utc",
    }).toLocal();

    // Create JavaScript Date objects from the local DateTime objects
    // This is necessary for react-big-calendar which expects Date objects
    const localStartDate = startDateTime.toJSDate();
    const localEndDate = endDateTime.toJSDate();

    return {
      ...item,
      id: item.id,
      start: localStartDate, // Combine date and start time
      end: localEndDate, // Combine date and end time
      title: item?.teacher?.fullName, // Use student's full name as title
      localStartTime: startDateTime.toFormat("hh:mm a"),
      localEndTime: endDateTime.toFormat("hh:mm a"),
      localDate: startDateTime.toFormat("yyyy-MM-dd"),
    };
  });
  return events;
};

export const getLesserID = (senderId, receiverId) => {
  return senderId < receiverId ? senderId : receiverId;
};

export const getGreaterID = (senderId, receiverId) => {
  return senderId < receiverId ? receiverId : senderId;
};

export const addDocToFirestore = async (
  senderId,
  receiverId,
  messageBody,
  senderProfile,
  receiverProfile
) => {
  // Step 1: Identify the chat document or create a new one
  const chatID = `${getLesserID(senderId, receiverId)}_${getGreaterID(
    senderId,
    receiverId
  )}`;
  const chatRef = firestore.collection("chats").doc(chatID);
  const chatDoc = await chatRef.get();

  if (!chatDoc.exists) {
    // Create a new chat document if it doesn't exist
    await chatRef.set({
      sender_uuid: senderId,
      receiver_uuid: receiverId,
      lastMessage: messageBody,
      senderProfileUrl: senderProfile || null, // Use null if senderProfile is undefined
      receiverProfileUrl: receiverProfile || null, // Use null if receiverProfile is undefined
    });
  } else {
    // Update the lastMessage field in the existing chat document
    /*   await chatRef.update({
      lastMessage: messageBody,
    });
  } */

    // Prepare update object with lastMessage
    const updateData = {
      lastMessage: messageBody,
    };
    // Check if senderProfileUrl and receiverProfileUrl exist in the document
    const currentData = chatDoc.data();

    //sender always be a student in db
    if (currentData.sender_uuid === senderId) {
      if (!currentData.senderProfileUrl && senderProfile != null) {
        updateData.senderProfileUrl = senderProfile;
      } else if (
        currentData.senderProfileUrl !== senderProfile &&
        senderProfile != null
      ) {
        updateData.senderProfileUrl = senderProfile;
      }
    }

    //Check currentID user (TEACHER) Image doesnot exist in db previously then add
    if (currentData.receiver_uuid === senderId) {
      if (!currentData?.receiverProfileUrl) {
        updateData.receiverProfileUrl = senderProfile;
      } else if (
        currentData.receiverProfileUrl !== senderProfile &&
        senderProfile != null
      ) {
        updateData.receiverProfileUrl = senderProfile;
      }
    }

    // Update the document with the prepared fields
    await chatRef.update(updateData);
  }

  // Step 2: Add a new document to the messages subcollection
  await chatRef.collection("messages").add(messageBody);
};

export const uploadAudioToFirebase = async (audioBlob) => {
  const storage = getStorage();
  const audioRef = ref(storage, `audio/${new Date().getTime()}.wav`); // unique timestamp

  try {
    await uploadBytes(audioRef, audioBlob);

    const audioUrl = await getDownloadURL(audioRef);
    // console.log("Audio uploaded successfully, URL: ", audioUrl);
    return audioUrl;
  } catch (error) {
    console.error("Error uploading audio to Firebase: ", error);
    return null;
  }
};

export const calculateRemainingTime = (date, startTime) => {
  const now = DateTime.local();
  const eventTime = DateTime.fromISO(`${date}T${startTime}`, {
    zone: "utc",
  }).toLocal();
  if (eventTime <= now) {
    return "Starting now";
  }
  const diff = eventTime
    .diff(now, ["months", "weeks", "days", "hours", "minutes"])
    .toObject();
  if (diff.months >= 1) {
    return `${Math.floor(diff.months)} month${
      diff.months >= 2 ? "s" : ""
    } remaining`;
  } else if (diff.weeks >= 1) {
    return `${Math.floor(diff.weeks)} week${
      diff.weeks >= 2 ? "s" : ""
    } remaining`;
  } else if (diff.days >= 1) {
    return `${Math.floor(diff.days)} day${diff.days >= 2 ? "s" : ""} remaining`;
  } else if (diff.hours >= 1) {
    return `${Math.floor(diff.hours)} hour${
      diff.hours >= 2 ? "s" : ""
    } remaining`;
  } else {
    return `${Math.floor(diff.minutes)} minute${
      diff.minutes >= 2 ? "s" : ""
    } remaining`;
  }
};

export const getStudentChatDataForUserWithLastMessage = async (
  userId,
  callback
) => {
  try {
    const chatsMap = new Map();

    const updateCallback = () => {
      const allChats = Array.from(chatsMap.values());
      // console.log("Total unique student chats:", allChats.length);
      callback(allChats);
    };

    const processSnapshot = (snapshot, sourceType) => {
      // Remove previous chats from this source
      for (let [chatId, chat] of chatsMap.entries()) {
        if (chat.source === sourceType) {
          chatsMap.delete(chatId);
        }
      }

      snapshot.docs.forEach((doc) => {
        const chatId = doc.id;
        const lastMessage = doc.data().lastMessage;

        if (!lastMessage) return;

        chatsMap.set(chatId, {
          chatId,
          ...doc.data(),
          lastMessage,
          source: sourceType,
        });
      });

      // console.log(`${sourceType} student chats updated:`, snapshot.docs.length);
      updateCallback();
    };

    const unsubscribeReceiver = firestore
      .collection("chats")
      .where("receiver_uuid", "==", userId)
      .onSnapshot((snapshot) => processSnapshot(snapshot, "receiver"));

    const unsubscribeSender = firestore
      .collection("chats")
      .where("sender_uuid", "==", userId)
      .onSnapshot((snapshot) => processSnapshot(snapshot, "sender"));

    return {
      unsubscribeSender,
      unsubscribeReceiver,
    };
  } catch (error) {
    console.error("Error getting student chat data:", error);
    throw error;
  }
};
export const getTeahcherChatDataForUserWithLastMessage = async (
  userId,
  callback
) => {
  try {
    const chatsMap = new Map();

    const updateCallback = () => {
      const allChats = Array.from(chatsMap.values()).sort(
        (a, b) =>
          b.lastMessage?.timestamp?.seconds - a.lastMessage?.timestamp?.seconds
      );
      callback(allChats);
    };

    const processSnapshot = (snapshot, sourceType) => {
      // remove old chats from same source
      for (let [chatId, chat] of chatsMap.entries()) {
        if (chat.source === sourceType) {
          chatsMap.delete(chatId);
        }
      }

      snapshot.docs.forEach((doc) => {
        const chatId = doc.id;
        const lastMessage = doc.data().lastMessage;

        if (!lastMessage) return;

        chatsMap.set(chatId, {
          chatId,
          ...doc.data(),
          lastMessage,
          source: sourceType,
        });
      });

      updateCallback();
    };

    const unsubscribeSender = firestore
      .collection("chats")
      .where("sender_uuid", "==", userId)
      .onSnapshot((snapshot) => processSnapshot(snapshot, "sender"));

    const unsubscribeReceiver = firestore
      .collection("chats")
      .where("receiver_uuid", "==", userId)
      .onSnapshot((snapshot) => processSnapshot(snapshot, "receiver"));

    return {
      unsubscribeSender,
      unsubscribeReceiver,
    };
  } catch (error) {
    console.error("Error getting teacher chat data:", error);
    throw error;
  }
};

// export const getTeahcherChatDataForUserVersion2 = async (userId, callback) => {
//   try {
//     // Use a Map to store all chats and track their source
//     const chatsMap = new Map();

//     const updateCallback = () => {
//       // Convert Map to array and call callback
//       const allChats = Array.from(chatsMap.values());
//       console.log("Total unique chats:", allChats.length);
//       callback(allChats);
//     };

//     const unsubscribeSender = firestore
//       .collection("chats")
//       .where("sender_uuid", "==", userId)
//       .onSnapshot((senderSnapshot) => {
//         // Remove all previous sender chats
//         for (let [chatId, chat] of chatsMap.entries()) {
//           if (chat.source === "sender") {
//             chatsMap.delete(chatId);
//           }
//         }

//         // Add new sender chats
//         senderSnapshot.docs.forEach((doc) => {
//           chatsMap.set(doc.id, {
//             chatId: doc.id,
//             lastMessage: doc.data().lastMessage,
//             source: "sender",
//           });
//         });

//         console.log("Sender chats updated:", senderSnapshot.docs.length);
//         updateCallback();
//       });

//     const unsubscribeReceiver = firestore
//       .collection("chats")
//       .where("receiver_uuid", "==", userId)
//       .onSnapshot((receiverSnapshot) => {
//         // Remove all previous receiver chats
//         for (let [chatId, chat] of chatsMap.entries()) {
//           if (chat.source === "receiver") {
//             chatsMap.delete(chatId);
//           }
//         }

//         // Add new receiver chats
//         receiverSnapshot.docs.forEach((doc) => {
//           chatsMap.set(doc.id, {
//             chatId: doc.id,
//             lastMessage: doc.data().lastMessage,
//             source: "receiver",
//           });
//         });

//         console.log("Receiver chats updated:", receiverSnapshot.docs.length);
//         updateCallback();
//       });

//     return {
//       unsubscribeSender,
//       unsubscribeReceiver,
//     };
//   } catch (error) {
//     console.error("Error getting chat data for user:", error);
//     throw error;
//   }
// };

export const getTeahcherChatDataForUserVersion2 = async (userId, callback) => {
  try {
    const chatsMap = new Map();

    const updateCallback = () => {
      const allChats = Array.from(chatsMap.values());
      // console.log("Total unique chats:", allChats.length);
      callback(allChats);
    };

    const processSnapshot = (snapshot, sourceType) => {
      // Remove previous chats from this source
      for (let [chatId, chat] of chatsMap.entries()) {
        if (chat.source === sourceType) {
          chatsMap.delete(chatId);
        }
      }

      snapshot.docs.forEach((doc) => {
        const chatId = doc.id;
        const newMessage = doc.data().lastMessage;

        if (!newMessage) return;

        const existingChat = chatsMap.get(chatId);

        // Initialize unseenCount
        let unseenCount = 0;

        if (newMessage.seen === false) {
          // If the message is unseen, increase count
          unseenCount = 1;
        }

        if (existingChat) {
          // Keep accumulating unseen messages
          unseenCount += existingChat.unseenCount || 0;
        }

        chatsMap.set(chatId, {
          chatId,
          lastMessage: newMessage,
          source: sourceType,
          unseenCount,
        });
      });

      // console.log(`${sourceType} chats updated:`, snapshot.docs.length);
      updateCallback();
    };

    // Listen to messages sent by this user (as sender)
    const unsubscribeSender = firestore
      .collection("chats")
      .where("sender_uuid", "==", userId)
      .onSnapshot((snapshot) => processSnapshot(snapshot, "sender"));

    // Listen to messages received by this user (as receiver)
    const unsubscribeReceiver = firestore
      .collection("chats")
      .where("receiver_uuid", "==", userId)
      .onSnapshot((snapshot) => processSnapshot(snapshot, "receiver"));

    return {
      unsubscribeSender,
      unsubscribeReceiver,
    };
  } catch (error) {
    console.error("Error getting chat data for user:", error);
    throw error;
  }
};

export const listenToUnseenMessages = (userId, callback) => {
  try {
    return (
      firestore
        .collectionGroup("messages")
        .where("receiverId", "==", userId)
        // .where("seen", "==", false)
        .onSnapshot((snapshot) => {
          const unseenMessages = [];

          snapshot.forEach((doc) => {
            const message = doc.data();
            const chatId = doc.ref.path.split("/")[1]; // Extract chatId from path

            unseenMessages.push({
              chatId,
              messageId: doc.id,
              ...message,
            });
          });
          // console.log("unseenMessages", unseenMessages);
          callback(unseenMessages);
        })
    );
  } catch (error) {
    console.error("Error listening to unseen messages:", error);
    throw error;
  }
};

export const markMessageAsSeen = async (chatId) => {
  try {
    // Update the seen field in lastMessage (if present)
    await firestore.collection("chats").doc(chatId).update({
      "lastMessage.seen": true,
    });

    // Update all unseen messages in the messages subcollection
    const messagesRef = firestore
      .collection("chats")
      .doc(chatId)
      .collection("messages");
    const unseenMessages = await messagesRef.where("seen", "==", false).get();

    const batch = firestore.batch();
    unseenMessages.forEach((doc) => {
      batch.update(doc.ref, { seen: true });
    });

    if (!unseenMessages.empty) {
      await batch.commit();
    }
    // console.log("Marked as seen:", chatId);
  } catch (error) {
    console.error("Failed to mark message as seen:", error);
  }
};

export const filterProfilePicture = (list, type = "profilePicture") => {
  if (!Array.isArray(list) || !type) return null;

  const matched = list.find((item) => item?.type === type);
  if (matched) return `${baseUrl}${matched.url}`;

  return null;
};

export const containsLink = (text) => {
  const urlRegex = /https?:\/\/[^\s/$.?#].[^\s]*/i;
  return urlRegex.test(text);
};

export const getDocumentUrls = (documents, type, name = "") => {
  let filterDocuments = [];
  if (type && documents?.length) {
    filterDocuments = documents?.filter((item) => item?.type === type);
  }
  return filterDocuments;
};

export const groupSlotsByDate = (slots) => {
  const groupedSlots = {};

  // Sort slots by date
  slots?.sort((a, b) => new Date(a.date) - new Date(b.date));

  slots?.forEach((slot) => {
    const date = slot.date;
    if (!groupedSlots[date]) {
      groupedSlots[date] = [];
    }
    groupedSlots[date].push(slot);
  });
  return groupedSlots;
};

export const getAudioDuration = (audioUrl) => {
  return new Promise((resolve, reject) => {
    const audio = new Audio(audioUrl);

    audio.onloadedmetadata = () => {
      const duration = audio.duration;
      resolve(duration);
    };

    audio.onerror = (error) => {
      reject("Error loading audio: " + error);
    };
  });
};

export const formatToAmPm = (timeString) => {
  return moment(timeString, "HH:mm:ss").format("h:mm A");
};

export const getStatusColor = (status) => {
  switch (status) {
    case "accepted":
      return {
        bg: "rgba(34, 197, 194, 0.16)",
        text: "#118D57",
      };
    case "pending":
      return {
        bg: "rgba(255, 171, 0, 0.16)",
        text: "#B76E00",
      };
    case "rejected":
      return {
        bg: "rgba(255, 86, 48, 0.16)",
        text: "#B71D18",
      };
    case "delivered":
      return {
        bg: "rgba(0, 148, 217, 0.16)",
        text: "#006C9C",
      };
    case "withdrawn":
      return {
        bg: "rgba(142, 51, 255, 0.16)",
        text: "#5119B7",
      };
    default:
      return {
        bg: "rgba(145, 158, 171, 0.16)",
        text: "#1C252E",
      };
  }
};

export const getOfferTypeColor = (type) => {
  switch (type) {
    case "retake":
      return {
        text: "#6f42c1",
        border: "rgba(111, 66, 193, 0.2)",
      };
    case "monthly":
      return {
        text: "#118D57",
        border: "#118D57",
      };
    case "demo":
      return {
        text: "red",
        border: "red",
      };
    default:
      return {
        text: "#198754",
        border: "rgba(25, 135, 84, 0.2)",
      };
  }
};

export function capitalizeFirstLetter(value) {
  if (!value || typeof value !== "string") return "";
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

export const teacherProfileCompletionObject = [
  {
    id: 1,
    name: "PERSONAL INFO",
    percentage: "15%",
    isCompleted: false,
  },
  {
    id: 2,
    name: "EDUCATION",
    percentage: "10%",
    isCompleted: false,
  },
  {
    id: 3,
    name: "DOCUMENTS",
    percentage: "25%",
    isCompleted: false,
  },
  {
    id: 4,
    name: "SLOTS",
    percentage: "20%",
    isCompleted: false,
  },
  {
    id: 5,
    name: "MODE",
    percentage: "10%",
    isCompleted: false,
  },
  {
    id: 6,
    name: "PREFERENCES",
    percentage: "20%",
    isCompleted: false,
  },
];

export function isDatePassed(dateInput) {
  let dateToCheck;

  if (typeof dateInput === "string") {
    // If it's a string date like "2025-06-23"
    dateToCheck = new Date(dateInput);
  } else if (typeof dateInput === "object" && dateInput.date) {
    // If it's an object with a date property (like your example)
    dateToCheck = new Date(dateInput.date);
  } else if (dateInput instanceof Date) {
    // If it's already a Date object
    dateToCheck = dateInput;
  } else {
    throw new Error(
      "Invalid date input. Expected string, Date object, or object with date property."
    );
  }

  if (isNaN(dateToCheck.getTime())) {
    throw new Error("Invalid date format");
  }

  // Get current date (without time for accurate comparison)
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Set the time to start of day for the date to check
  dateToCheck.setHours(0, 0, 0, 0);

  // Return true if the date has passed (is before today)
  return dateToCheck < today;
}

/**
 * Checks if a given UTC date and time has passed in the user's local timezone.
 * @param {Object|string} dateInput - Either an object with `date` and `startTime`, or a date string.
 * @param {string|null} timeInput - Optional time string (HH:mm:ss).
 * @returns {boolean} True if the datetime has passed, false otherwise.
 */
export function isDateTimePassed(dateInput, timeInput = null) {
  let dateTimeToCheck;

  // Handle object input
  if (typeof dateInput === "object" && dateInput.date && dateInput.startTime) {
    dateTimeToCheck = DateTime.fromISO(
      `${dateInput.date}T${dateInput.startTime}`,
      {
        zone: "utc",
      }
    ).setZone(DateTime.local().zoneName); // Convert to local time
  }

  // Handle string + time input
  else if (typeof dateInput === "string" && timeInput) {
    dateTimeToCheck = DateTime.fromISO(`${dateInput}T${timeInput}`, {
      zone: "utc",
    }).setZone(DateTime.local().zoneName);
  }

  // Fallback: check date only
  else {
    return (
      DateTime.fromISO(dateInput).startOf("day") <
      DateTime.local().startOf("day")
    );
  }

  if (!dateTimeToCheck.isValid) {
    throw new Error(
      `Invalid date/time format: ${dateTimeToCheck.invalidReason}`
    );
  }

  const now = DateTime.local();

  return dateTimeToCheck < now;
}

export const hasFormErrors = (errors) => {
  if (!errors) return false;

  // Check top-level error fields
  const topLevelErrors = Object.values(errors).some(
    (val) => typeof val === "string" && val.trim() !== ""
  );

  // Check nested socials errors
  const socialErrors = errors.socials
    ? Object.values(errors.socials).some((val) => val?.trim() !== "")
    : false;

  return topLevelErrors || socialErrors;
};

export const formatCenterDate = (date) => {
  try {
    return DateTime.fromJSDate(date).toFormat("d LLL yyyy");
  } catch {
    return "";
  }
};

export function capitalizeEachWord(str) {
  return str
    .split(" ")
    .map((word) => {
      if (word.length === 0) {
        return "";
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}
